import React, { useState, useEffect, createContext, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Global, { extendJWT, isAuthenticated, isTokenNearExpiration, onUserLogout } from "../util/Global";
import { Menu, MenuItem, Box, Button, useTheme, useMediaQuery } from '@mui/material';
import axios from "axios";
import { HeaderLanguageCurrency } from "./Utils";




export const HeaderContext = createContext()

const Header = ({ children }) => {
  const [cartCount, setcartCount] = useState(0)



  const CART_URL = Global.backend + "/index.php/api/panier/showall";


  useEffect(() => {
    if (!isAuthenticated()) {
      return
    }
    const requestOne = axios.get(CART_URL);

    axios.all([requestOne]).then(axios.spread((...responses) => {
      const responseOne = responses[0].data.length ? responses[0].data.length : 0

      setcartCount(responseOne)
    })).catch((err) => {
      //showAlert("error", t("request.errorCart"))
    })
  }, [])





  return (
    <HeaderContext.Provider value={{ cartCount, setcartCount }}>
      <HeaderComponent cartCount={cartCount} />
      {children}
    </HeaderContext.Provider>
  )
}


function HeaderComponent({ cartCount }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isHomePage, setIsHomePage] = useState(false);

  const [isForumMenuOpen, setIsForumMenuOpen] = useState(false);
  const [isHeaderShown, setisHeaderShown] = useState(false)
  const [isMobileMenuOpen, setisMobileMenuOpen] = useState(false)
  const [isMenuOpenUser, setIsMenuOpenUser] = useState(false);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const userMenuAnchorRef = useRef(null);
  const menuAnchorRef = useRef(null);




  const allowedHeaderPaths = [
    "/",
    "/login",
    "/inscription",
    "/detailAnnonce",
    "/annonces",
    "/promotion",
    "/actualite",
    "/addproductlist",
    "/annuaire",
    "/annuaires",
    "/entreprise",
    "/apropos",
    "/cart",
    "/commandList",
    "/contactUs",
    "/dashboard/user/detailEquipement",
    "/detail",
    "/detailproduit",
    "/equipements",
    "/categories",
    "/filter",
    "/marketplace",
    "/messageverfimail",
    "/settings",
  ]





  useEffect(() => {
    setisHeaderShown(allowedHeaderPaths.includes("/" + location.pathname.split("/")[1]))
    setIsHomePage(location.pathname === "/")


    if (isTokenNearExpiration()) {
      extendJWT()
    }
  }, [location]);



  const toggleForumMenu = () => {
    setIsForumMenuOpen(!isForumMenuOpen);
  };

  const toggleMenuUser = () => {
    setIsMenuOpenUser(!isMenuOpenUser);
  };

  if (!isHeaderShown) {
    return null
  } else
    return (
      <header id="masthead" className="header ttm-bgcolor-darkgrey ttm-header-style-02 d-print-none">
        <div
          id="site-header-menu"
          className={isHomePage ? "site-header-menu" : "site-header-menu ttm-bgcolor-darkgrey"}
        >
          <div className={"site-header-menu-inner " + (isHomePage ? "ttm-stickable-header" : "ttm-stickable-header-1 fixed-header")}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="site-navigation d-flex align-items-center justify-content-between">
                    <div className="site-branding">
                      <div
                        className="home-link"
                        title="Aqovo"
                        rel="home"
                        onClick={() => navigate("/")}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="row">
                          <div className="col-xl-12">
                            <img
                              id="logo-img"
                              className="img-fluid auto_size"
                              src={require("../assets/FrontOffice/images/techoneyy.png")}
                              alt="logo-img"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-box-block">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className={"btn-show-menu-mobile menubar menubar--squeeze" + (isMobileMenuOpen ? " is-active" : "")} onClick={() => setisMobileMenuOpen(!isMobileMenuOpen)}>
                          <span className="menubar-box">
                            <span className="menubar-inner"></span>
                          </span>
                        </div>
                        <nav className={"main-menu menu-mobile" + (isMobileMenuOpen ? " show" : "")} id="menu" style={{ overflowX: isSmallScreen ? "auto" : "inherit" }}>
                          <ul className="menu d-flex align-items-center">

                            <li className={"mega-menu-item" + (location.pathname == "/" ? " active" : "")}>
                              <NavLink to="/">{t("homePage")}</NavLink>
                            </li>


                            <li className={"mega-menu-item" + (location.pathname == "/marketplace" ? " active" : "")}>
                              <NavLink to="/marketplace">{t("navigation2.1")}</NavLink>
                            </li>
                            <li className={"mega-menu-item" + (location.pathname == "/promotion" ? " active" : "")}>
                              <NavLink to="/promotion">{t("navigation3.1")}</NavLink>
                            </li>
                            <li className={"mega-menu-item" + (location.pathname == "/annuaire" ? " active" : "")}>
                              <NavLink to="/annuaire">{t("navigation5.1")}</NavLink>
                            </li>


                            {isSmallScreen ?
                              <li className={"mega-menu-item" + (["/annonces", "/actualite", "/categories"].includes(location.pathname) ? " active" : "")}>
                                <NavLink ref={menuAnchorRef} onClick={toggleForumMenu}>{t("navigation6.1")}</NavLink>
                                <Menu
                                  anchorEl={menuAnchorRef.current}
                                  open={isForumMenuOpen}
                                  onClick={toggleForumMenu}
                                >
                                  <MenuItem onClick={() => navigate("/annonces")}>{t("navigation7.1")}</MenuItem>
                                  <MenuItem onClick={() => navigate("/actualite")}>{t("navigation8.1")}</MenuItem>
                                  <MenuItem onClick={() => navigate("/contactUs")}>{t("navigation4.1")}</MenuItem>
                                </Menu>
                              </li>
                              :
                              <li className={"mega-menu-item" + (["/annonces", "/actualite", "/categories"].includes(location.pathname) ? " active" : "")}>
                                <NavLink>{t("navigation6.1")}</NavLink>
                                <ul className="mega-submenu">
                                  <li><NavLink to="/annonces">{t("navigation7.1")}</NavLink></li>
                                  <li><NavLink to="/actualite">{t("navigation8.1")}</NavLink></li>
                                  <li ><NavLink to="/contactUs">{t("navigation4.1")}</NavLink></li>
                                </ul>
                              </li>
                            }





                            <HeaderLanguageCurrency />
                          </ul>
                        </nav>
                      </div>
                    </div>
                    {!isAuthenticated() ? (
                      <NavLink style={{ marginRight: isSmallScreen ? 50 : 0, textWrap: "nowrap" }} to="/login" className="headerLoginButton">
                        {t("navigation14.1")}
                      </NavLink>
                    ) : (
                      !isSmallScreen ?
                        <nav className={"main-menu menu-mobile"} id="menu">
                          <ul className="menu" style={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                            <li className={"mega-menu-item"}>
                              <NavLink>{localStorage.getItem("prenom")} {localStorage.getItem("nom")}</NavLink>
                              <ul className="mega-submenu">
                                <li><NavLink to="/dashboard">{t("navigation12.1")}</NavLink></li>
                                <li>
                                  <NavLink
                                    onClick={() => {
                                      onUserLogout()
                                    }}
                                    to="/login"
                                  >
                                    {t("navigation13.1")}
                                  </NavLink>
                                </li>
                              </ul>
                            </li>
                            <li className="mega-menu-item">
                              <div
                                className="header_cart"
                                onClick={() => navigate("/cart")}
                                style={{ cursor: "pointer" }}
                              >
                                <span className="cart_btn">
                                  <div className="cart_icon">
                                    <i className="fa fa-shopping-cart fa-2x"></i>
                                  </div>
                                  <div className="cart_count ttm-bgcolor-skincolor">
                                    <span>{cartCount}</span>
                                  </div>
                                </span>
                              </div>
                            </li>
                          </ul>
                        </nav>
                        :
                        <Box sx={{ display: 'flex', alignItems: 'center', marginRight: isSmallScreen ? 5 : 0 }} >
                          <Button color="inherit" ref={userMenuAnchorRef} onClick={toggleMenuUser}>
                            {localStorage.getItem("prenom")} {localStorage.getItem("nom")}
                          </Button>
                          <Menu
                            anchorEl={userMenuAnchorRef.current}
                            open={isMenuOpenUser}
                            onClick={toggleMenuUser}
                          >
                            <MenuItem onClick={() => navigate("/dashboard")}>{t("navigation12.1")}</MenuItem>
                            <MenuItem onClick={() => { onUserLogout(); navigate("/login") }}>{t("navigation13.1")}</MenuItem>
                          </Menu>
                          <div
                            className="header_cart"
                            onClick={() => navigate("/cart")}
                            style={{ cursor: "pointer" }}
                          >
                            <span className="cart_btn">
                              <div className="cart_icon">
                                <i className="fa fa-shopping-cart fa-2x"></i>
                              </div>
                              <div className="cart_count ttm-bgcolor-skincolor">
                                <span>{cartCount}</span>
                              </div>
                            </span>
                          </div>
                        </Box>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
};



export default Header